import * as React from "react";

export const ProjectsIcon = ({ length }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={70}
    height={70}
    viewBox="0 0 59.712 48.38"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        y1={0.292}
        x2={0.918}
        y2={0.292}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#1a73e8" />
        <stop offset={1} stopColor="#1a73e8" />
      </linearGradient>
      <filter
        id="projection-screen"
        x={0}
        y={0}
        width={42.212}
        height={42.212}
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx={1} dy={1} input="SourceAlpha" />
        <feGaussianBlur stdDeviation={0.5} result="blur" />
        <feFlood floodColor="#606060" floodOpacity={0.188} />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
      <linearGradient
        id="linear-gradient-2"
        y1={0.292}
        x2={0.918}
        y2={0.292}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#12aac4" />
        <stop offset={1} stopColor="#1a73e8" />
      </linearGradient>
      <filter
        id="Ellipse_239"
        x={21.712}
        y={10.38}
        width={38}
        height={37.999}
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx={1} dy={1} input="SourceAlpha" />
        <feGaussianBlur stdDeviation={0.5} result="blur-2" />
        <feFlood floodColor="#606060" floodOpacity={0.188} />
        <feComposite operator="in" in2="blur-2" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Group_8261" data-name="Group 8261" transform="translate(0.5 0.499)">
      <g
        transform="matrix(1, 0, 0, 1, -0.5, -0.5)"
        filter="url(#projection-screen)"
      >
        <g
          id="projection-screen-2"
          data-name="projection-screen"
          transform="translate(0.5 0.5)"
          fill="url(#linear-gradient)"
        >
          <path
            d="M39.212,6.893V0H0V6.893H2.3V27.724H0v2.3H18.457v2.5a3.446,3.446,0,1,0,2.3,0v-2.5H39.212v-2.3h-2.3V6.893ZM19.606,36.915a1.149,1.149,0,1,1,1.149-1.149A1.15,1.15,0,0,1,19.606,36.915ZM2.3,2.3H36.915V4.6H2.3Zm32.32,25.427H4.6V6.893H34.617Z"
            stroke="none"
          />
          <path
            d="M 0 0 L 39.21239852905273 0 L 39.21239852905273 6.892799377441406 L 36.91479873657227 6.892799377441406 L 36.91479873657227 27.72438812255859 L 39.21239852905273 27.72438812255859 L 39.21239852905273 30.02198791503906 L 20.7549991607666 30.02198791503906 L 20.7549991607666 32.51718902587891 C 22.09212875366211 32.99142074584961 23.05259895324707 34.26834106445313 23.05259895324707 35.76599884033203 C 23.05259895324707 37.66633987426758 21.50653839111328 39.21239852905273 19.60619926452637 39.21239852905273 C 17.70584869384766 39.21239852905273 16.15979957580566 37.66633987426758 16.15979957580566 35.76599884033203 C 16.15979957580566 34.26834106445313 17.12026977539063 32.99142074584961 18.45739936828613 32.51718902587891 L 18.45739936828613 30.02198791503906 L 0 30.02198791503906 L 0 27.72438812255859 L 2.297599792480469 27.72438812255859 L 2.297599792480469 6.892799377441406 L 0 6.892799377441406 L 0 0 Z M 36.91479873657227 4.595199584960938 L 36.91479873657227 2.297599792480469 L 2.297599792480469 2.297599792480469 L 2.297599792480469 4.595199584960938 L 36.91479873657227 4.595199584960938 Z M 34.6171989440918 27.72438812255859 L 34.6171989440918 6.892799377441406 L 4.595199584960938 6.892799377441406 L 4.595199584960938 27.72438812255859 L 34.6171989440918 27.72438812255859 Z M 19.60619926452637 36.91479873657227 C 20.23964881896973 36.91479873657227 20.7549991607666 36.39944076538086 20.7549991607666 35.76599884033203 C 20.7549991607666 35.13254928588867 20.23964881896973 34.6171989440918 19.60619926452637 34.6171989440918 C 18.97274971008301 34.6171989440918 18.45739936828613 35.13254928588867 18.45739936828613 35.76599884033203 C 18.45739936828613 36.39944076538086 18.97274971008301 36.91479873657227 19.60619926452637 36.91479873657227 Z"
            stroke="none"
            fill="#1a73e8"
          />
        </g>
      </g>
      <g transform="matrix(1, 0, 0, 1, -0.5, -0.5)" filter="url(#Ellipse_239)">
        <g
          id="Ellipse_239-2"
          data-name="Ellipse 239"
          transform="translate(22.21 10.88)"
          stroke="#fff"
          strokeWidth={2}
          fill="url(#linear-gradient-2)"
        >
          <ellipse cx={17.5} cy={17.5} rx={17.5} ry={17.5} stroke="none" />
          <ellipse cx={17.5} cy={17.5} rx={16.5} ry={16.5} fill="none" />
        </g>
      </g>
      <text
        id="_0"
        data-name="0"
        transform="translate(35.62 32.527)"
        fill="#fff"
        fontSize={14}
        fontFamily="SegoeUI-Bold, Segoe UI"
        fontWeight={500}
      >
        {String(length).split("").length == 1 ? (
          <tspan x="7" y="0">
            {length}
          </tspan>
        ) : null}

        {String(length).split("").length == 2 ? (
          <tspan x="10" y="0">
            {length}
          </tspan>
        ) : null}
        {String(length).split("").length == 3 ? (
          <tspan x="14" y="0">
            {length}
          </tspan>
        ) : null}
        {String(length).split("").length == 4 ? (
          <tspan x="19" y="0">
            {length}
          </tspan>
        ) : null}
      </text>
    </g>
  </svg>
);

export const TasksIcon = ({ length }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={70}
    height={70}
    viewBox="0 0 60.62 47.33"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        y1={0.292}
        x2={0.918}
        y2={0.292}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#12aac4" />
        <stop offset={1} stopColor="#1a73e8" />
      </linearGradient>
      <filter
        id="Path_8987"
        x={22.62}
        y={9.331}
        width={38}
        height={37.999}
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx={1} dy={1} input="SourceAlpha" />
        <feGaussianBlur stdDeviation={0.5} result="blur" />
        <feFlood floodColor="#606060" floodOpacity={0.188} />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Group_8273" data-name="Group 8273" transform="translate(0 -0.001)">
      <g id="fi-br-layers" transform="translate(0 0.001)">
        <path
          id="Path_183"
          data-name="Path 183"
          d="M1.485,16.646l15.176,9.2a5.651,5.651,0,0,0,5.882,0l15.176-9.2a3.093,3.093,0,0,0,0-5.274L22.542,2.157a5.646,5.646,0,0,0-5.882,0h0l-15.176,9.2a3.093,3.093,0,0,0,0,5.274ZM19.182,6.4a.809.809,0,0,1,.84,0L32.539,14,20.021,21.6a.809.809,0,0,1-.84,0L6.664,14Z"
          transform="translate(0.005 -1.331)"
          fill="#1a73e8"
        />
        <path
          id="Path_184"
          data-name="Path 184"
          d="M21.707,21.908a4.2,4.2,0,0,1-4.2,0L3.712,13.891a2.519,2.519,0,0,0-2.469-.031A2.362,2.362,0,0,0,0,15.926H0a2.36,2.36,0,0,0,1.189,2.035l13.793,8.012a9.215,9.215,0,0,0,9.248,0l13.793-8.017a2.36,2.36,0,0,0,1.189-2.031h0a2.362,2.362,0,0,0-1.243-2.066,2.519,2.519,0,0,0-2.469.03Z"
          transform="translate(0 6.856)"
          fill="#1a73e8"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_8987)">
        <g
          id="Path_8987-2"
          data-name="Path 8987"
          transform="translate(23.12 9.83)"
          fill="url(#linear-gradient)"
        >
          <path
            d="M 17.5 33.99924087524414 C 13.09269046783447 33.99924087524414 8.949170112609863 32.28298187255859 5.832729816436768 29.16660308837891 C 2.716300010681152 26.05024147033691 1 21.90682220458984 1 17.4996223449707 C 1 13.09242248535156 2.716300010681152 8.949002265930176 5.832729816436768 5.832642555236816 C 8.949170112609863 2.716262340545654 13.09269046783447 1.000002384185791 17.5 1.000002384185791 C 21.90731048583984 1.000002384185791 26.05083084106445 2.716262340545654 29.16727066040039 5.832642555236816 C 32.28369903564453 8.949002265930176 34 13.09242248535156 34 17.4996223449707 C 34 21.90682220458984 32.28369903564453 26.05024147033691 29.16727066040039 29.16660308837891 C 26.05083084106445 32.28298187255859 21.90731048583984 33.99924087524414 17.5 33.99924087524414 Z"
            stroke="none"
          />
          <path
            d="M 17.5 2.000003814697266 C 13.35979080200195 2.000003814697266 9.467399597167969 3.612253189086914 6.539829254150391 6.539752960205078 C 3.612279891967773 9.467243194580078 2 13.35953140258789 2 17.4996223449707 C 2 21.63971328735352 3.612279891967773 25.53200149536133 6.539829254150391 28.45949172973633 C 9.467399597167969 31.38699340820313 13.35979080200195 32.99924087524414 17.5 32.99924087524414 C 21.64020919799805 32.99924087524414 25.53260040283203 31.38699340820313 28.46017074584961 28.45949172973633 C 31.38772010803223 25.53200149536133 33 21.63971328735352 33 17.4996223449707 C 33 13.35953140258789 31.38772010803223 9.467243194580078 28.46017074584961 6.539752960205078 C 25.53260040283203 3.612253189086914 21.64020919799805 2.000003814697266 17.5 2.000003814697266 M 17.5 3.814697265625e-06 C 27.16497993469238 3.814697265625e-06 35 7.83485221862793 35 17.4996223449707 C 35 27.16439247131348 27.16497993469238 34.99924087524414 17.5 34.99924087524414 C 7.835020065307617 34.99924087524414 0 27.16439247131348 0 17.4996223449707 C 0 7.83485221862793 7.835020065307617 3.814697265625e-06 17.5 3.814697265625e-06 Z"
            stroke="none"
            fill="#fff"
          />
        </g>
      </g>
      <text
        id="_10"
        data-name={10}
        transform="translate(31.212 32.332)"
        fill="#fff"
        fontSize={14}
        fontFamily="SegoeUI-Bold, Segoe UI"
        fontWeight={500}
      >
        {String(length).split("").length == 1 ? (
          <tspan x="13" y="0">
            {length}
          </tspan>
        ) : null}
        {String(length).split("").length == 2 ? (
          <tspan x="17" y="0">
            {length}
          </tspan>
        ) : null}
        {String(length).split("").length == 3 ? (
          <tspan x="21" y="0">
            {length}
          </tspan>
        ) : null}
        {String(length).split("").length == 4 ? (
          <tspan x="24" y="0">
            {length}
          </tspan>
        ) : null}
      </text>
    </g>
  </svg>
);

export const FouramIcon = ({ length }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={70}
    height={70}
    viewBox="0 0 61.379 56.587"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        y1={0.292}
        x2={0.918}
        y2={0.292}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#1a73e8" />
        <stop offset={1} stopColor="#1a73e8" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        y1={0.292}
        x2={0.918}
        y2={0.292}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#12aac4" />
        <stop offset={1} stopColor="#1a73e8" />
      </linearGradient>
      <filter
        id="Ellipse_395"
        x={23.379}
        y={18.587}
        width={38}
        height={38}
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx={1} dy={1} input="SourceAlpha" />
        <feGaussianBlur stdDeviation={0.5} result="blur" />
        <feFlood floodColor="#606060" floodOpacity={0.188} />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Group_8274" data-name="Group 8274" transform="translate(0.5 0.544)">
      <g id="Group_8266" data-name="Group 8266" transform="translate(0 -0.001)">
        <path
          id="fi-br-comments"
          d="M13.429,30.638H5.689A5.827,5.827,0,0,1,0,24.681V15.716A16.151,16.151,0,0,1,5.526,3.421,13.737,13.737,0,0,1,17.5.309,15.024,15.024,0,0,1,29.035,12.673a15.213,15.213,0,0,1-3.079,12.179A15.911,15.911,0,0,1,13.429,30.638ZM14.595,5.11a9.069,9.069,0,0,0-5.98,2.257,11.1,11.1,0,0,0-3.738,8.349v8.965a.832.832,0,0,0,.813.851h7.74a11.147,11.147,0,0,0,8.8-3.976,10.007,10.007,0,0,0,2-8.018,10.126,10.126,0,0,0-7.672-8.223,9.714,9.714,0,0,0-1.964-.206ZM34.1,16.652a13.209,13.209,0,0,0-1.625-1.169,18.728,18.728,0,0,1-.9,5.676,9.34,9.34,0,0,1,2.558,6.416v7.318a.832.832,0,0,1-.813.851H27.047A9.441,9.441,0,0,1,20.108,32.9a19.89,19.89,0,0,1-5.33,1.07,13.067,13.067,0,0,0,1.164,1.738,14.11,14.11,0,0,0,11.1,5.141h6.274a5.827,5.827,0,0,0,5.689-5.957V27.575a14.34,14.34,0,0,0-4.9-10.919Z"
          transform="translate(0 0.006)"
          stroke="rgba(0,0,0,0)"
          strokeMiterlimit={10}
          strokeWidth={1}
          fill="url(#linear-gradient)"
        />
        <g
          transform="matrix(1, 0, 0, 1, -0.5, -0.54)"
          filter="url(#Ellipse_395)"
        >
          <g
            id="Ellipse_395-2"
            data-name="Ellipse 395"
            transform="translate(23.88 19.09)"
            stroke="#fff"
            strokeWidth={2}
            fill="url(#linear-gradient-2)"
          >
            <circle cx={17.5} cy={17.5} r={17.5} stroke="none" />
            <circle cx={17.5} cy={17.5} r={16.5} fill="none" />
          </g>
        </g>
        <text
          id="_5"
          data-name={5}
          transform="translate(37.379 41.543)"
          fill="#fff"
          fontSize={14}
          fontFamily="SegoeUI-Bold, Segoe UI"
          fontWeight={500}
        >
          {String(length).split("").length == 1 ? (
            <tspan x="7" y="0">
              {length}
            </tspan>
          ) : null}
          {String(length).split("").length == 2 ? (
            <tspan x="11" y="0">
              {length}
            </tspan>
          ) : null}
          {String(length).split("").length == 3 ? (
            <tspan x="14" y="0">
              {length}
            </tspan>
          ) : null}
          {String(length).split("").length == 4 ? (
            <tspan x="18" y="0">
              {length}
            </tspan>
          ) : null}
        </text>
      </g>
    </g>
  </svg>
);

export const UsersIcon = ({ length }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={70}
    height={70}
    viewBox="0 0 60.776 55.555"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        y1={0.292}
        x2={0.918}
        y2={0.292}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#12aac4" />
        <stop offset={1} stopColor="#1a73e8" />
      </linearGradient>
      <filter
        id="Path_9005"
        x={22.776}
        y={17.555}
        width={38}
        height={38}
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx={1} dy={1} input="SourceAlpha" />
        <feGaussianBlur stdDeviation={0.5} result="blur" />
        <feFlood floodColor="#606060" floodOpacity={0.188} />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Group_8275" data-name="Group 8275" transform="translate(0 0)">
      <g id="customer_1_" data-name="customer (1)" transform="translate(0 0)">
        <circle
          id="Ellipse_396"
          data-name="Ellipse 396"
          cx={7.032}
          cy={7.032}
          r={7.032}
          transform="translate(14.1)"
          fill="#1a73e8"
        />
        <circle
          id="Ellipse_397"
          data-name="Ellipse 397"
          cx={4.445}
          cy={4.445}
          r={4.445}
          transform="translate(2.021 5.173)"
          fill="#1a73e8"
        />
        <path
          id="Path_8994"
          data-name="Path 8994"
          d="M129.545,239.945c3.676-.295,6.872,0,9.628,2.19,4.612,3.552,3.725,8.334,3.725,14.184a2.894,2.894,0,0,1-2.944,2.831c-17.747,0-18.453.55-19.506-1.69-.345-.758-.251-.517-.251-7.765A9.979,9.979,0,0,1,129.545,239.945Z"
          transform="translate(-110.416 -223.101)"
          fill="#1a73e8"
        />
        <path
          id="Path_8995"
          data-name="Path 8995"
          d="M383.3,240.538c2.034,0,3.61-.188,5.358,1.244-4.2,4.288-3.491,8.562-3.491,15.162,0,.349.566.244-4.893.244a2.46,2.46,0,0,1-2.462-2.452v-8.743A5.478,5.478,0,0,1,383.3,240.538Z"
          transform="translate(-377.81 -223.726)"
          fill="#1a73e8"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_9005)">
        <g
          id="Path_9005-2"
          data-name="Path 9005"
          transform="translate(23.28 18.05)"
          fill="url(#linear-gradient)"
        >
          <path
            d="M 17.5 34 C 13.09269046783447 34 8.949179649353027 32.28369903564453 5.83273983001709 29.16725921630859 C 2.716300010681152 26.05081939697266 1 21.90731048583984 1 17.5 C 1 13.09269046783447 2.716300010681152 8.949179649353027 5.83273983001709 5.83273983001709 C 8.949179649353027 2.716300010681152 13.09269046783447 1 17.5 1 C 21.90731048583984 1 26.05081939697266 2.716300010681152 29.16725921630859 5.83273983001709 C 32.28369903564453 8.949179649353027 34 13.09269046783447 34 17.5 C 34 21.90731048583984 32.28369903564453 26.05081939697266 29.16725921630859 29.16725921630859 C 26.05081939697266 32.28369903564453 21.90731048583984 34 17.5 34 Z"
            stroke="none"
          />
          <path
            d="M 17.5 2 C 13.35980033874512 2 9.467409133911133 3.612279891967773 6.539850234985352 6.539850234985352 C 3.612279891967773 9.467409133911133 2 13.35980033874512 2 17.5 C 2 21.64019966125488 3.612279891967773 25.53258895874023 6.539850234985352 28.46014976501465 C 9.467409133911133 31.38772010803223 13.35980033874512 33 17.5 33 C 21.64019966125488 33 25.53258895874023 31.38772010803223 28.46014976501465 28.46014976501465 C 31.38772010803223 25.53258895874023 33 21.64019966125488 33 17.5 C 33 13.35980033874512 31.38772010803223 9.467409133911133 28.46014976501465 6.539850234985352 C 25.53258895874023 3.612279891967773 21.64019966125488 2 17.5 2 M 17.5 0 C 27.16497993469238 0 35 7.835020065307617 35 17.5 C 35 27.16497993469238 27.16497993469238 35 17.5 35 C 7.835020065307617 35 0 27.16497993469238 0 17.5 C 0 7.835020065307617 7.835020065307617 0 17.5 0 Z"
            stroke="none"
            fill="#fff"
          />
        </g>
      </g>
      <text
        id="_300"
        data-name={300}
        transform="translate(27.79 41.069)"
        fill="#fff"
        fontSize={14}
        fontFamily="SegoeUI-Bold, Segoe UI"
        fontWeight={500}
      >
        {String(length).split("").length == 1 ? (
          <tspan x="16" y="0">
            {length}
          </tspan>
        ) : null}
        {String(length).split("").length == 2 ? (
          <tspan x="20" y="0">
            {length}
          </tspan>
        ) : null}
        {String(length).split("").length == 3 ? (
          <tspan x="24" y="0">
            {length}
          </tspan>
        ) : null}
        {String(length).split("").length == 4 ? (
          <tspan x="28" y="0">
            {length}
          </tspan>
        ) : null}
      </text>
    </g>
  </svg>
);

export const CommunityIcon = ({ length }) => (
  <svg
    id="Group_8277"
    data-name="Group 8277"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={70}
    height={70}
    viewBox="0 0 59.5 55.289"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        y1={0.292}
        x2={0.918}
        y2={0.292}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#12aac4" />
        <stop offset={1} stopColor="#1a73e8" />
      </linearGradient>
      <filter
        id="Path_9006"
        x={21.5}
        y={17.289}
        width={38}
        height={38}
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx={1} dy={1} input="SourceAlpha" />
        <feGaussianBlur stdDeviation={0.5} result="blur" />
        <feFlood floodColor="#606060" floodOpacity={0.188} />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <path
      id="sync"
      d="M16.568,25.117A17.687,17.687,0,0,1,16.4,22.7,17.2,17.2,0,0,1,26.837,6.769a7.081,7.081,0,0,1-.505-2.636c0-.054,0-.108,0-.162A19.977,19.977,0,0,0,13.688,22.7a20.678,20.678,0,0,0,.276,3.362l.13-.08A6.527,6.527,0,0,1,16.568,25.117Zm28.612,4.8a4.008,4.008,0,0,1,2.433-1.926,3.89,3.89,0,0,1,3.044.414,4.216,4.216,0,0,1,1.468,5.646,3.951,3.951,0,0,1-5.476,1.512,4.1,4.1,0,0,1-1.868-2.51A4.234,4.234,0,0,1,45.18,29.919ZM33.057,8.266a4.078,4.078,0,0,1-4.011-4.133,4.011,4.011,0,1,1,8.019,0A4.075,4.075,0,0,1,33.057,8.266ZM13.584,30.916a4.1,4.1,0,0,1,1.868-2.509,3.951,3.951,0,0,1,5.477,1.513,4.234,4.234,0,0,1,.4,3.136,4.1,4.1,0,0,1-1.864,2.51,3.954,3.954,0,0,1-5.48-1.513A4.231,4.231,0,0,1,13.584,30.916ZM39.273,6.77A17.2,17.2,0,0,1,49.709,22.7a17.527,17.527,0,0,1-.166,2.412,6.586,6.586,0,0,1,2.472.87l.13.08a20.68,20.68,0,0,0,.276-3.362A19.977,19.977,0,0,0,39.776,3.972c0,.054,0,.107,0,.161A7.086,7.086,0,0,1,39.273,6.77Zm4.053,29.446a16.259,16.259,0,0,1-20.541,0,6.771,6.771,0,0,1-1.963,1.771l-.136.078a18.919,18.919,0,0,0,24.738,0l-.133-.077A6.791,6.791,0,0,1,43.326,36.216Z"
      transform="translate(-13.447 0.001)"
      fill="#1a73e8"
      fillRule="evenodd"
    />
    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_9006)">
      <g
        id="Path_9006-2"
        data-name="Path 9006"
        transform="translate(22 17.79)"
        fill="url(#linear-gradient)"
      >
        <path
          d="M 17.5 33.99924087524414 C 13.09269046783447 33.99924087524414 8.949170112609863 32.28298187255859 5.832729816436768 29.16660308837891 C 2.716300010681152 26.05024147033691 1 21.90682220458984 1 17.4996223449707 C 1 13.09242248535156 2.716300010681152 8.949002265930176 5.832729816436768 5.832642555236816 C 8.949170112609863 2.716262340545654 13.09269046783447 1.000002384185791 17.5 1.000002384185791 C 21.90731048583984 1.000002384185791 26.05083084106445 2.716262340545654 29.16727066040039 5.832642555236816 C 32.28369903564453 8.949002265930176 34 13.09242248535156 34 17.4996223449707 C 34 21.90682220458984 32.28369903564453 26.05024147033691 29.16727066040039 29.16660308837891 C 26.05083084106445 32.28298187255859 21.90731048583984 33.99924087524414 17.5 33.99924087524414 Z"
          stroke="none"
        />
        <path
          d="M 17.5 2.000003814697266 C 13.35979080200195 2.000003814697266 9.467399597167969 3.612253189086914 6.539829254150391 6.539752960205078 C 3.612279891967773 9.467243194580078 2 13.35953140258789 2 17.4996223449707 C 2 21.63971328735352 3.612279891967773 25.53200149536133 6.539829254150391 28.45949172973633 C 9.467399597167969 31.38699340820313 13.35979080200195 32.99924087524414 17.5 32.99924087524414 C 21.64020919799805 32.99924087524414 25.53260040283203 31.38699340820313 28.46017074584961 28.45949172973633 C 31.38772010803223 25.53200149536133 33 21.63971328735352 33 17.4996223449707 C 33 13.35953140258789 31.38772010803223 9.467243194580078 28.46017074584961 6.539752960205078 C 25.53260040283203 3.612253189086914 21.64020919799805 2.000003814697266 17.5 2.000003814697266 M 17.5 3.814697265625e-06 C 27.16497993469238 3.814697265625e-06 35 7.83485221862793 35 17.4996223449707 C 35 27.16439247131348 27.16497993469238 34.99924087524414 17.5 34.99924087524414 C 7.835020065307617 34.99924087524414 0 27.16439247131348 0 17.4996223449707 C 0 7.83485221862793 7.835020065307617 3.814697265625e-06 17.5 3.814697265625e-06 Z"
          stroke="none"
          fill="#fff"
        />
      </g>
    </g>
    <text
      id="_2"
      data-name={2}
      transform="translate(36 40.789)"
      fill="#fff"
      fontSize={14}
      fontFamily="SegoeUI-Bold, Segoe UI"
      fontWeight={500}
    >
      {String(length).split("").length == 1 ? (
        <tspan x="7" y="0">
          {length}
        </tspan>
      ) : null}
      {String(length).split("").length == 2 ? (
        <tspan x="10" y="0">
          {length}
        </tspan>
      ) : null}
      {String(length).split("").length == 3 ? (
        <tspan x="13" y="0">
          {length}
        </tspan>
      ) : null}
      {String(length).split("").length == 4 ? (
        <tspan x="16" y="0">
          {length}
        </tspan>
      ) : null}
    </text>
  </svg>
);

export const MessagesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Group_8277"
    data-name="Group 8277"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={70}
    height={70}
    viewBox="0 0 43 43"
  >
    <g data-name="Group 8356">
      <g data-name="chat (3)">
        <g data-name="Group 8347">
          <g data-name="Group 8346">
            <path
              data-name="Path 9195"
              d="M20.745 6.893H7.959a1.066 1.066 0 0 0 0 2.131h12.787a1.066 1.066 0 0 0 0-2.131Z"
              fill="#1a73e8"
              stroke="#1a73e8"
            />
          </g>
        </g>
        <g data-name="Group 8349">
          <g data-name="Group 8348">
            <path
              data-name="Path 9196"
              d="M16.483 11.156H7.959a1.066 1.066 0 0 0 0 2.131h8.524a1.066 1.066 0 0 0 0-2.131Z"
              fill="#1a73e8"
              stroke="#1a73e8"
            />
          </g>
        </g>
        <g data-name="Group 8351">
          <g data-name="Group 8350">
            <path
              data-name="Path 9197"
              d="M23.942.5H4.762A4.266 4.266 0 0 0 .5 4.762v21.311a1.065 1.065 0 0 0 .614.965 1.081 1.081 0 0 0 .452.1 1.065 1.065 0 0 0 .682-.247l6.1-5.081h15.6a4.266 4.266 0 0 0 4.252-4.261V4.762A4.266 4.266 0 0 0 23.942.5Zm2.131 17.049a2.133 2.133 0 0 1-2.131 2.131H7.959a1.064 1.064 0 0 0-.682.247L2.631 23.8V4.762a2.133 2.133 0 0 1 2.131-2.131h19.18a2.133 2.133 0 0 1 2.131 2.131Z"
              fill="#1a73e8"
              stroke="#1a73e8"
            />
          </g>
        </g>
        <g data-name="Group 8353">
          <g data-name="Group 8352">
            <path
              data-name="Path 9198"
              d="M30.335 9.024a1.066 1.066 0 0 0 0 2.131 2.133 2.133 0 0 1 2.131 2.131v18.027l-3.6-2.877a1.074 1.074 0 0 0-.665-.232H13.286a2.133 2.133 0 0 1-2.131-2.131v-1.066a1.066 1.066 0 0 0-2.131 0v1.066a4.267 4.267 0 0 0 4.262 4.262h14.538l5.036 4.03a1.066 1.066 0 0 0 1.733-.833V13.286a4.266 4.266 0 0 0-4.258-4.262Z"
              fill="#1a73e8"
              stroke="#1a73e8"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const PostIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={60}
    viewBox="0 0 43 43"
  >
    <g fill="#1a73e8" data-name="Group 8342">
      <path
        data-name="Path 9197"
        d="M1.826 40.195h32.887a1.827 1.827 0 0 0 1.827-1.827v-18.27a1.827 1.827 0 0 0-3.654 0v16.443H3.653V7.308h16.446a1.827 1.827 0 1 0 0-3.654H1.826A1.827 1.827 0 0 0-.001 5.481v32.887a1.827 1.827 0 0 0 1.827 1.827Z"
      />
      <path
        data-name="Path 9198"
        d="M18.27 15.225V20.1a1.827 1.827 0 0 0 1.827 1.827h4.873a1.827 1.827 0 0 0 1.291-.535l13.4-13.4a1.827 1.827 0 0 0 0-2.585L34.787.535a1.827 1.827 0 0 0-2.583 0l-13.4 13.4a1.827 1.827 0 0 0-.534 1.29Zm3.654.758L33.495 4.41l2.289 2.29-11.572 11.571h-2.288Z"
      />
    </g>
  </svg>
);

export const AddPostIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={60}
    viewBox="0 0 43 43"
  >
    <defs>
      <linearGradient
        id="b"
        y1={0.292}
        x2={0.918}
        y2={0.292}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#12aac4" />
        <stop offset={1} stopColor="#1a73e8" />
      </linearGradient>
      <filter
        id="a"
        x={19.146}
        y={20.598}
        width={42}
        height={42}
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx={1} dy={1} />
        <feGaussianBlur stdDeviation={0.5} result="blur" />
        <feFlood floodColor="#606060" floodOpacity={0.188} />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g data-name="Group 8345">
      <g fill="#1a73e8">
        <path
          data-name="Path 9197"
          d="M1.827 40.195h32.887a1.827 1.827 0 0 0 1.827-1.827v-18.27a1.827 1.827 0 0 0-3.654 0v16.443H3.654V7.308H20.1a1.827 1.827 0 1 0 0-3.654H1.827A1.827 1.827 0 0 0 0 5.481v32.887a1.827 1.827 0 0 0 1.827 1.827Z"
        />
        <path
          data-name="Path 9198"
          d="M18.271 15.225V20.1a1.827 1.827 0 0 0 1.827 1.827h4.873a1.827 1.827 0 0 0 1.291-.535l13.4-13.4a1.827 1.827 0 0 0 0-2.585L34.788.535a1.827 1.827 0 0 0-2.583 0l-13.4 13.4a1.827 1.827 0 0 0-.534 1.29Zm3.654.758L33.496 4.41l2.289 2.29-11.572 11.571h-2.288Z"
        />
      </g>
      <g transform="translate(-.004 -.002)" filter="url(#a)">
        <g
          data-name="Ellipse 438"
          transform="translate(19.65 21.1)"
          stroke="#fff"
          strokeWidth={2}
          fill="#1a73e8"
        >
          <circle cx={10.5} cy={10.5} r={10.5} stroke="none" />
          <circle cx={10.5} cy={10.5} r={9.5} fill="none" />
        </g>
      </g>
      <text
        data-name="+"
        transform="translate(30.646 49.098)"
        fill="#fff"
        fontSize={20}
        fontFamily="SegoeUI-Bold, Segoe UI"
        fontWeight={500}
      >
        <tspan x={6} y={-11.5}>
          {"+"}
        </tspan>
      </text>
    </g>
  </svg>
);
